export const RRO_WARNING_TEXT = {
	title: 'Warning!',
	message:
		'This absence is automatically set between planned activities. Editing it may lead to scheduling issues, so proceed only if necessary.',
	checkboxLabel: 'I acknowledge the risk and wish to proceed with a correction.',
};
